export const vacationTypes: {name: string, value: string}[] = [
  {name: 'natural', value: 'natural'},
  {name: 'working', value: 'working'},
];